export enum Messages {
	// -------------------------------------------------------------------------
	// module: rpa — bots
	// -------------------------------------------------------------------------
	BOT_SAVE_SUCCESS = 'Your RPA bot was successfully saved.',
	BOT_DELETE_SUCCESS = 'Your RPA bot has been deleted successfully.',
	BOT_CREATE_SUCCESS = 'Your new RPA bot was successfully created.',
	BOT_PING_SUCCESS = 'The RPA bot was successfully and pinged and is available.',
	BOT_RELEASE_SUCCESS = 'The RPA bot was succesfully released from the currently registered machine.',
	BOT_NOTIFICATION_SUCCESS = 'A test RPA bot notification has been created and sent successfully.',

	// module: rpa — credentials
	CREDENTIAL_CREATE_SUCCESS = 'Your new RPA credential was successfully added.',
	CREDENTIAL_UPDATE_SUCCESS = 'Your RPA credential was successfully updated.',
	CREDENTIAL_NO_CHANGE = 'No change was detected, no change has been made.',
	CREDENTIAL_DELETE_SUCCESS = 'Your RPA credential was successfully deleted.',

	// module: rpa — flows
	FLOW_SAVE_SUCCESS = 'Your RPA flow was successfully saved.',
	FLOW_CREATE_SUCCESS = 'Your new RPA flow was successfully created.',
	FLOW_DELETE_SUCCESS = 'Your RPA flow was successfully deleted.',
	FLOW_RUN_SUCCESS = 'Your RPA flow has now been scheduled to run as soon as an available bot can pick it up.',
	FLOW_NOTIFICATION_SUCCESS = 'A test RPA flow notification has been created and sent successfully.',
	FLOW_TRIGGER_SAVE_SUCCESS = 'Your RPA trigger was successfully saved.',
	FLOW_NOTIFICATION_SAVE_SUCCESS = 'Your RPA notification was successfully saved.',
	FLOW_BOT_ASSIGN_SUCCESS = 'Your RPA bot was successfully assigned.',

	// module: rpa — jobs
	JOB_SAVE_SUCCESS = 'Your RPA job has successfully been saved.',
	JOB_CREATE_SUCCESS = 'Your new RPA job was successfully created.',
	JOB_DELETE_SUCCESS = 'Your RPA job was successfully deleted.',
	JOB_STOP_SUCCESS = 'The RPA job was successfully cancelled.',
	JOB_ABORT_SUCCESS = 'The RPA job was successfully aborted.',

	// module: rpa — general
	RPA_MIN_EDITOR = 'You need at least one editor.',
	RPA_INVALID_PARAMS = 'The given paramaters are not valid, please check all fields are filled.',

	// -------------------------------------------------------------------------
	// module: ai
	// -------------------------------------------------------------------------
	AI_MODEL_DELETE_SUCCERR = 'Your model has been deleted successfully.',

	// -------------------------------------------------------------------------
	// module: create — environments
	// -------------------------------------------------------------------------
	ENVS_SAVE_SUCCESS = 'The default environments were saved successfully.',
	ENVS_NO_SPACE = 'You have hit your maximum environment limit, you are unable to add any more environments.',
	ENV_CREATE_SUCCESS = 'Your environment has been scheduled for creation.',
	ENV_SUSPEND_SUCCESS = 'The environment has been scheduled to be suspended successfully.',
	ENV_RESUME_SUCCESS = 'The environment has been scheduled to be resumed successfully.',
	ENV_UPGRADE_SUCCESS = 'The environment has been scheduled to be upgraded successfully.',
	ENV_DELETE_SUCCESS = 'The environment was successfully deleted.',
	ENV_DOMAIN_CHANGE_SUCCESS = 'The environment domain has been changed successfully.',

	// module: create — accelerators
	ACCELERATOR_NOT_FOUND = 'That accelerator was not found, please make sure you have typed it correctly.',
	ACCELERATOR_INVALID_CODE = 'The accelerator code provided was invalid, please make sure you have typed it correctly.',

	// module: create — applications
	APP_CREATE_SUCCESS = 'Your new application is being created, we will notify you once it is finished.',
	APP_UPDATE_SUCCESS = 'Your application has been successfully updated.',
	APP_INVITE_SUCCESS = 'We have successfully sent an invite email to that user.',
	APP_DELETE_SUCCESS = 'We have successfully scheduled this application for deletion.',
	APP_BACKUP_VERSION = 'This application is too old, and does not support self-service backups.',
	APP_NAME_TOO_SHORT = 'The application name is too short, please provide at least 2 characters.',
	APP_NAME_TOO_LONG = 'The application name is too long, no more than 32 characters is allowed.',

	// module: create — backups
	BACKUP_DELETE_SUCCESS = 'The backup was deleted successfully.',
	BACKUP_RESTORE_SUCCESS = 'The backup has been scheduled to be restored.',
	BACKUP_CREATE_SUCCESS = 'The backup has been scheduled to be created.',

	// module: create — snapshots
	SNAPSHOT_APPROVE_SUCCESS = 'The snapshot was successfully approved.',
	SNAPSHOT_REJECT_SUCCESS = 'The snapshot was successfully rejected.',

	// module: create — resources
	RESOURCES_SAVE_SUCCESS = 'The resource settings were saved successfully.',
	RESOURCES_SAVE_WITH_ERRORS = 'Some of the resource settings were not saved.',
	RESOURCES_APP_SAVE_SUCCESS = 'The application resource settings were saved successfully',
	RESOURCES_APP_ENV_SAVE_SUCCESS = 'The application environment resource settings were saved successfully',
	RESOURCES_SAVE_ERROR = 'An error occurred. Cannot save resource settings.',
	RESOURCES_APP_SAVE_ERROR = 'An error occurred. Cannot save application resource settings.',
	RESOURCES_APP_ENV_SAVE_ERROR = 'An error occurred. Cannot save application environment resource settings.',
	RESOURCES_DB_BOOST_INCREASE_ERROR = 'Unable to change database memory boost level. Insufficient resources on this controller. Please contact Netcall support for help.',
	RESOURCES_DB_BOOST_DECREASE_ERROR = 'Unable to change memory boost level. Please try again later or call Netcall support.',

	// -------------------------------------------------------------------------
	// module: users
	// -------------------------------------------------------------------------
	USER_CREATE_SUCCESS = 'The new user was successfully saved.',
	USER_UPDATE_SUCCESS = 'The existing user was successfully updated.',
	USER_DELETE_SUCCESS = 'The user was successfully deleted.',
	USER_SENDRESET_SUCCESS = 'A reset password email was successfully sent to the user.',
	USER_ACCESS_DENIED = 'You do not have permission to access this page.',

	// -------------------------------------------------------------------------
	// module: auth
	// -------------------------------------------------------------------------
	PASSWORD_RESET_SUCCESS = 'Your password was successfully reset.',
	PASSWORD_SETUP_SUCCESS = 'Your password was successfully set.',
	ACCOUNT_CHANGE_SUCCESS = 'Your account details were successfully updated.',
	LOGIN_TOKEN_EXPIRED = 'The given code has expired, please click the resend button for a new code.',
	LOGIN_TOKEN_RESEND = 'A new code has been sent to the mobile number connected to your account.',
	LOGOUT_SUCCESS = 'You were successfully logged out.',

	// -------------------------------------------------------------------------
	// module: licensing
	// -------------------------------------------------------------------------
	LICENSING_SAVE_SUCCESS = 'The licensing information was successfully saved.',

	// -------------------------------------------------------------------------
	// module: settings
	// -------------------------------------------------------------------------
	SETTINGS_SAVE_SUCCESS = 'Controller settings were saved successfully.',

	// -------------------------------------------------------------------------
	// validation — regex
	// -------------------------------------------------------------------------
	REGEX_INVALID_SLACKURL = 'The given slack webhook URL is not valid, please make sure you copied it correctly.',
	REGEX_INVALID_TEAMSURL = 'The given teams webhook URL is not valid, please make sure you copied it correctly.',
	REGEX_INVALID_TEAMS_WORKFLOW_URL = 'The given teams workflow webhook URL is not valid, please make sure you copied it correctly.',
	REGEX_INVALID_EMAIL = 'The given email is not valid, please make sure you typed it correctly.',
}
